import { supabase } from '../../shared/supabase/supabaseClient';

export type AppealReasonCode =
  | 'wrong_party'
  | 'evidence_error'
  | 'already_fixed'
  | 'extraordinary'
  | 'other';

export const APPEAL_REASON_LABELS: Record<AppealReasonCode, string> = {
  wrong_party: 'Se apuntó al negocio equivocado',
  evidence_error: 'Hay un error en el registro',
  already_fixed: 'El problema ya se resolvió',
  extraordinary: 'Pasó algo fuera de lo común',
  other: 'Otro',
};

export type OrgTrustAppealSurface = {
  ok: boolean;
  status: string;
  appealable: boolean;
  appeal_status: string;
  open_appeal: {
    id: string;
    status: string;
    statement: string;
    staff_public_reply: string | null;
  } | null;
  target_event: {
    id: string;
    window_days: number;
    to_status: string;
  } | null;
};

export async function fetchOrgTrustAppealSurface(): Promise<OrgTrustAppealSurface | null> {
  const { data, error } = await supabase.rpc('get_trust_appeal_surface', {
    p_actor_type: 'merchant_org',
  });
  if (error) {
    console.warn('[orgTrustAppeal]', error.message);
    return null;
  }
  return data as OrgTrustAppealSurface;
}

export async function submitOrgTrustAppeal(input: {
  enforcementEventId: string;
  reasonCode: AppealReasonCode;
  statement: string;
}): Promise<{ ok: true } | { ok: false; message: string }> {
  const { error } = await supabase.rpc('submit_trust_appeal', {
    p_actor_type: 'merchant_org',
    p_enforcement_event_id: input.enforcementEventId,
    p_reason_code: input.reasonCode,
    p_statement: input.statement,
    p_evidence_urls: [],
  });
  if (error) {
    const m = error.message.toLowerCase();
    if (m.includes('appeal_window')) return { ok: false, message: 'Pasó el plazo para apelar.' };
    if (m.includes('already')) return { ok: false, message: 'Ya hay una apelación abierta.' };
    if (m.includes('statement_too_short')) {
      return { ok: false, message: 'Escribí al menos 20 caracteres.' };
    }
    return { ok: false, message: error.message };
  }
  return { ok: true };
}
